/* KIJIN 2026-10 新ヘッダー（全ページ共通）
   1. ヘッダーの透明→白：トップ（data-transparent）だけ。scrollY>24 またはメニューが開いているとき .is-solid
   2. スマホメニュー：開閉・Esc で閉じる・メニュー内のリンクで閉じる・幅が 760px を超えたら閉じる（見本 top/page.js と同じ動き）
   3. 計測の印：data-cta の付いた要素をクリックしたら Shopify.analytics.publish('kijin_cta_click', {cta, page})
      （Shopify.analytics が無いときは何もしない）
   4. お問い合わせフォームの見えない欄（2026-10-05）：どこから来たか・最初に開いたページ・広告の番号（このファイルの末尾）
   5. 押された数を GA4 へ（2026-10・目印 KJ-GA4-CTA v2）：3 と同じ時に、サイト本体の Google タグへ kijin_cta_click を1つ渡す。
      印の無い電話のリンク（page-tel）と、前からの形のフォームの送信ボタン（page-submit）も、GA4 にだけ数える
   6. フォームの控え（2026-10-23）：送信の瞬間に中身の控えを Google の受け口へ。Shopify が通知を捨てても台帳に残す（このファイルの末尾） */
(function () {
  'use strict';

  var header = document.getElementById('kj-header');
  var toggle = header ? header.querySelector('.menu-toggle') : null;
  var nav = document.getElementById('kj-site-navigation');

  if (header && toggle && nav) {
    var transparent = header.hasAttribute('data-transparent');

    var isOpen = function () {
      return toggle.getAttribute('aria-expanded') === 'true';
    };

    var syncHeader = function () {
      if (!transparent) return;
      header.classList.toggle('is-solid', window.scrollY > 24 || isOpen());
    };

    var menu = function (open, focus) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      toggle.innerHTML = open ? 'CLOSE <span>−</span>' : 'MENU <span>＋</span>';
      nav.classList.toggle('is-open', open);
      syncHeader();
      if (open && focus) {
        var first = nav.querySelector('a');
        if (first) first.focus();
      }
    };

    toggle.addEventListener('click', function () {
      menu(!isOpen(), true);
    });
    Array.prototype.forEach.call(nav.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () {
        menu(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        menu(false);
        toggle.focus();
      }
    });
    window.addEventListener('scroll', syncHeader, { passive: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760 && isOpen()) menu(false);
      syncHeader();
    });
    syncHeader();
  }

  /* 5. 押された数を GA4 へ（2026-10 追加・目印 KJ-GA4-CTA v2）
     2026-10-14：新しい GA4（G-V76NZ59CY8）にも送る（古い GA4 と新しい GA4 に、1回ずつ）
     サイト本体の Google タグ（Shopify の「Google & YouTube」アプリが置く window.gtag）があるときだけ、
     出来事 kijin_cta_click を1つ渡す。Google タグを、ここでは作らない（window.gtag が無ければ、何もしない）。
     - 宛先の番号（KJ_GA4_ID＝古い GA4・KJ_GA4_ID_NEW＝新しい GA4）は、アプリが「ページを開いた」を送っている
       GA4 の番号と同じにしておく。違う番号を書くと、Google タグが、その番号の部品を自分で読み込みに行く
       → GA4 のつなぎ先を替えたら（古い GA4 を止めるときも）、ここも直す
     - 送る項目：cta_name と content_id（どちらもボタンの印）・content_type（kijin_cta）。ほかは Google タグが自分で付ける物だけ
     - メニューのリンク（印が header-・footer- で始まる物と mobile-menu）は数えない。
       ただし、ご相談・来店予約・電話・送信で終わる印（header-contact など）は数える
     - 印は「英小文字で始まり、英小文字・数字・-・_ で50字まで」だけ通す
     - Google タグがまだ無いとき：0.5秒おきに10回まで待つ。押してから6秒を過ぎた分は送らない（後からまとめて送らない）。
       入れ物（window.gtag）だけがある間に押した分は、Google タグの本体が読み込まれた時に送られる
     - アカウント・注文・チェックアウトのページでは送らない
     - テーマエディタの中では送らない
     - カスタムピクセルなど、同じ出来事を送る別の仕掛けと、両方は入れない（数が2倍になる）
     - ここで何が起きても、ページの動きは止めない */
  var KJ_GA4_ID = 'G-0FCYCYNNC6';
  var KJ_GA4_ID_NEW = 'G-V76NZ59CY8';
  var kjGa4Send = function (cta, born, tries) {
    try {
      var age = new Date().getTime() - born;
      if (age < 0 || age >= 6000) return;
      if (typeof window.gtag !== 'function') {
        if (tries < 10) {
          window.setTimeout(function () { kjGa4Send(cta, born, tries + 1); }, 500);
        }
        return;
      }
      window.gtag('event', 'kijin_cta_click', {
        send_to: [KJ_GA4_ID, KJ_GA4_ID_NEW],
        cta_name: cta,
        content_type: 'kijin_cta',
        content_id: cta
      });
    } catch (err) {
      /* 数えられないだけ */
    }
  };
  var kjGa4 = function (cta) {
    try {
      if (typeof cta !== 'string' || !/^[a-z][a-z0-9_-]{0,49}$/.test(cta)) return;
      if (/^(header|footer)-|^mobile-menu$/.test(cta) && !/(contact|reservation|tel|submit)$/.test(cta)) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (/^\/(?:\d+\/)?(?:account|orders|checkouts)(?:\/|$)/.test(window.location.pathname)) return;
      kjGa4Send(cta, new Date().getTime(), 0);
    } catch (err) {
      /* 数えられないだけ */
    }
  };

  /* 印の無い所（GA4 にだけ数える。Shopify の合図は、これまでどおり印のある所だけ）
     - 電話のリンク（href が tel: で始まる）→ page-tel
     - 前からの形のフォーム（id が contact-us-page。お問い合わせ・来店予約など）の送信ボタン → page-submit
     どのページで押されたかは、Google タグが付けるページのアドレスで分かる */
  var kjGa4Unmarked = function (target) {
    try {
      if (!target || !target.closest) return;
      if (target.closest('a[href^="tel:"]')) kjGa4('page-tel');
      else if (target.closest('#contact-us-page [type="submit"]')) kjGa4('page-submit');
    } catch (err) {
      /* 数えられないだけ */
    }
  };

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-cta]') : null;
    if (!el) {
      kjGa4Unmarked(e.target);
      return;
    }
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        analytics.publish('kijin_cta_click', {
          cta: el.getAttribute('data-cta'),
          page: window.location.pathname
        });
      }
    } catch (err) {
      /* 計測の失敗でページの動きを止めない */
    }
    kjGa4(el.getAttribute('data-cta'));
  }, true);
})();

/* 4. お問い合わせフォームの見えない欄（2026-10-05）
   どこから来たか・最初に開いたページ・広告の番号 を、フォームの中の input[data-kj-src] に入れる。
   - 欄は最初 disabled（＝送られない）。値があるものだけ disabled を外す。値が無い欄は、欄ごと送らない
   - 名前・書き方・長さは、受け取る側（ご相談の台帳）との約束のとおり
       どこから来たか      utm: <source> / <medium> / <campaign> ｜ 参照元: <ホスト名> ｜ 直接   （200字まで）
                           30日以内に広告から来ていた人は、後ろに「 ｜ 30日以内の広告: utm: …」を足す
       最初に開いたページ  アドレスの「/」から後ろ。「?」から後ろは付けない                    （300字まで）
       広告の番号          gclid:<値>（ほかに gbraid:・wbraid:）                               （200字まで）
   - 覚える場所は sessionStorage（このタブを閉じるまで）。ほかのサイト・広告・目印（utm）つきで開いたページを
     「最初に開いたページ」として覚え、サイトの中を移っても同じ値を送る
   - サイトの中から来たのに記録が無いとき（別のタブで開いた等）は、分からないので入れない
   - AD_KEEP_DAYS：広告の番号だけを、その日数だけ localStorage に覚える（0＝覚えない。2026-10-06 石川さんのお答えで 30 に）
   - 2026-10-29（目印 KJ-AD-KEEP v2）：広告の番号と一緒に、そのときの言葉の印（utm。どの言葉で来たか）も覚える。
     後日 広告を通らずに来てご相談くださったとき、「どこから来たか」はその日の来方のまま、後ろに
     「 ｜ 30日以内の広告: utm: …」を足す（その日に別の utm つきで来たときも足す）。覚える場所・日数・鍵の名前は同じ
     （v1 の時に覚えた分は言葉の印が無いので、広告の番号だけが出る）
   - ここで何が起きても、ページの動きは止めない */
(function () {
  'use strict';
  try {
    var VISIT_KEY = 'kj_visit_v1';
    var AD_KEY = 'kj_ad_v1';
    var AD_KEEP_DAYS = 30;
    var LIMITS = { came_from: 200, first_page: 300, ad_id: 200 };
    var WANT = { utm_source: 1, utm_medium: 1, utm_campaign: 1, gclid: 1, gbraid: 1, wbraid: 1 };

    /* 改行・タブなどを落として1行にし、長さを切る */
    var clean = function (value, max) {
      var s = String(value == null ? '' : value)
        .replace(/[\u0000-\u001f\u007f-\u009f\u2028\u2029]+/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/^ +| +$/g, '');
      if (s.length > max) {
        s = s.slice(0, max);
        var last = s.charCodeAt(s.length - 1);
        if (last >= 0xd800 && last <= 0xdbff) s = s.slice(0, -1);
      }
      return s;
    };

    var readParams = function () {
      var out = {};
      var parts = String(window.location.search || '').replace(/^\?/, '').split('&');
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        var key = eq < 0 ? parts[i] : parts[i].slice(0, eq);
        var val = eq < 0 ? '' : parts[i].slice(eq + 1);
        try { key = decodeURIComponent(key.replace(/\+/g, ' ')); } catch (e1) { /* そのまま */ }
        if (WANT[key] !== 1 || out[key] !== undefined) continue;
        try { val = decodeURIComponent(val.replace(/\+/g, ' ')); } catch (e2) { /* そのまま */ }
        out[key] = clean(val, 200);
      }
      return out;
    };

    var hostOf = function (url) {
      var m = /^[a-z][a-z0-9+.\-]*:\/\/(?:[^\/?#@]*@)?([^\/?#:]+)/i.exec(String(url || ''));
      return m ? m[1].toLowerCase() : '';
    };
    var bare = function (host) {
      return String(host || '').toLowerCase().replace(/^www\./, '');
    };
    var load = function (store, key) {
      try {
        var raw = store.getItem(key);
        var obj = raw ? JSON.parse(raw) : null;
        return obj && typeof obj === 'object' ? obj : null;
      } catch (e3) {
        return null;
      }
    };
    var save = function (store, key, obj) {
      try { store.setItem(key, JSON.stringify(obj)); } catch (e4) { /* 保存できなくても続ける */ }
    };

    var session = null;
    try { session = window.sessionStorage; } catch (e5) { session = null; }

    var q = readParams();
    var adNow = q.gclid ? 'gclid:' + q.gclid : (q.gbraid ? 'gbraid:' + q.gbraid : (q.wbraid ? 'wbraid:' + q.wbraid : ''));
    var hasUtm = !!(q.utm_source || q.utm_medium || q.utm_campaign);
    var refHost = hostOf(document.referrer);
    var sameSite = !!refHost && bare(refHost) === bare(window.location.hostname);
    var external = !!refHost && !sameSite;
    var arrived = hasUtm || !!adNow || external;

    var visit = session ? load(session, VISIT_KEY) : null;
    if (arrived || !visit) {
      if (!arrived && sameSite) {
        visit = { from: '', page: '', ad: '' };
      } else {
        visit = {
          from: hasUtm
            ? 'utm: ' + (q.utm_source || '-') + ' / ' + (q.utm_medium || '-') + ' / ' + (q.utm_campaign || '-')
            : (external ? '参照元: ' + refHost : '直接'),
          page: String(window.location.pathname || '/'),
          ad: adNow || (visit && typeof visit.ad === 'string' ? visit.ad : '')
        };
        if (session) save(session, VISIT_KEY, visit);
      }
    }

    var adOut = typeof visit.ad === 'string' ? visit.ad : '';
    var keptFrom = '';
    if (AD_KEEP_DAYS > 0) {
      var local = null;
      try { local = window.localStorage; } catch (e6) { local = null; }
      if (local) {
        var now = new Date().getTime();
        if (adNow) {
          save(local, AD_KEY, { v: adNow, f: hasUtm ? visit.from : '', t: now });
        } else if (!adOut) {
          var kept = load(local, AD_KEY);
          if (kept && typeof kept.v === 'string' && typeof kept.t === 'number' &&
              now - kept.t >= 0 && now - kept.t <= AD_KEEP_DAYS * 86400000) {
            adOut = kept.v;
            keptFrom = typeof kept.f === 'string' && kept.f.indexOf('utm: ') === 0 ? kept.f : '';
          } else if (kept) {
            try { local.removeItem(AD_KEY); } catch (e7) { /* 消せなくても続ける */ }
          }
        }
      }
    }

    var firstPage = clean(String(typeof visit.page === 'string' ? visit.page : '').split(/[?#]/)[0], LIMITS.first_page);
    if (firstPage.charAt(0) !== '/') firstPage = '';
    var cameFrom = typeof visit.from === 'string' ? visit.from : '';
    if (keptFrom && cameFrom !== keptFrom) {
      cameFrom = (cameFrom ? cameFrom + ' ｜ ' : '') + '30日以内の広告: ' + keptFrom;
    }
    var values = {
      came_from: clean(cameFrom, LIMITS.came_from),
      first_page: firstPage,
      ad_id: clean(adOut, LIMITS.ad_id)
    };

    var fill = function () {
      var fields = document.querySelectorAll('input[data-kj-src]');
      for (var i = 0; i < fields.length; i++) {
        var v = values[fields[i].getAttribute('data-kj-src')];
        if (typeof v === 'string' && v) {
          fields[i].value = v;
          fields[i].disabled = false;
        } else {
          fields[i].value = '';
          fields[i].disabled = true;
        }
      }
    };

    fill();
    /* 戻るボタンなどでページが復元されたとき・テーマエディタで段を差し替えたとき */
    window.addEventListener('pageshow', fill);
    document.addEventListener('shopify:section:load', fill);
  } catch (err) {
    /* 見えない欄が入らないだけ。フォームは今までどおり送れる */
  }
})();

/* 6. フォームの控え（2026-10-23・目印 KJ-FORM-CAPTURE v1）
   なぜ：Shopify は、お問い合わせの中身で迷惑と判断すると、通知メールを送らずに捨てる
   （2026-10-21 15:16 の1件で判明・Shopify サポートのチケット 71366824）。
   お客様が「送信」を押した瞬間に、同じ中身の控えを Google の受け口（Apps Script）へ送り、石川さんのドライブに残す。
   Air の業務管理アプリが毎時それを読み、通知メールと突き合わせる（通知が無ければ台帳に行を作って知らせる）。
   - 対象：Shopify 標準のお問い合わせフォーム（見えない欄 form_type が contact）。KIJIN・キイノクスの全部
   - 送信を押した時：見えない欄 contact[控えID] をフォームの先頭に足す（通知メールにも同じ番号が出る＝突き合わせの鍵）。
     控えは navigator.sendBeacon で送る（ページが移っても届く・お客様の画面は待たせない）
   - 完了の画面（KIJIN＝?contact_posted=true・キイノクス＝/pages/kiinnox_〇〇_thanks）を開いた時：
     「送れた」の合図を同じ番号で1回だけ送る（番号は sessionStorage に30分だけ覚え、使ったら消す）
   - 送らない欄：Shopify の内部の欄（form_type・utf8・authenticity_token・return_to・確認画面の form_key・return_path・skp）・ロボット判定の答え・空の欄・
     使えない（disabled）欄・選ばれていないチェック
   - FC_URL が空のとき・テーマエディタの中では、何もしない
   - 受け口が止まっていても、Shopify への送信は止めない（ここで何が起きても、ページの動きは止めない） */
(function () {
  'use strict';

  var FC_URL = 'https://script.google.com/macros/s/AKfycbx8kaM3fg1Fg5_FDpLp9NIPSf9sdYh8KtxhLvJCfGY2i_7UCjErDsHRZD7qDke4YY4/exec';  /* Apps Script のウェブアプリ（KIJIN フォームの控え・2026-10-24 公開 v1） */
  var FC_TOKEN = 'kjfc1';     /* 受け口と同じ合言葉（秘密ではない。でたらめな送信をふるい落とすだけ） */
  var FC_KEY = 'kj_fc_last';
  var FC_TTL = 30 * 60 * 1000;
  var SKIP = {
    form_type: 1, utf8: 1, authenticity_token: 1, return_to: 1, form_key: 1, return_path: 1, skp: 1,
    'h-captcha-response': 1, 'g-recaptcha-response': 1, 'contact[控えID]': 1
  };

  try {
    if (!FC_URL || !navigator.sendBeacon) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var session = null;
    try { session = window.sessionStorage; } catch (e1) { session = null; }

    var siteOf = function () {
      return /^\/pages\/kiinnox_/.test(location.pathname) || document.querySelector('[data-kx-form-root]') ? 'kiinnox' : 'kijin';
    };

    var send = function (o) {
      try {
        o.t = FC_TOKEN;
        o.site = siteOf();
        o.at = new Date().toISOString();
        o.page = (location.pathname + location.search).slice(0, 300);
        navigator.sendBeacon(FC_URL, new Blob([JSON.stringify(o)], { type: 'text/plain;charset=UTF-8' }));
      } catch (e2) {
        /* 控えが送れないだけ */
      }
    };

    var newId = function () {
      return 'fc-' + Date.now().toString(36) + (Math.random().toString(36) + '00000000').slice(2, 10);
    };

    var isContact = function (f) {
      if (!f || !f.elements || !f.querySelector) return false;
      var t = f.querySelector('input[name="form_type"]');
      return !!(t && t.value === 'contact');
    };

    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (!isContact(f)) return;
        var hid = f.querySelector('input[name="contact[控えID]"]');
        /* ロボット判定の確認画面（/challenge）で送り直すときは、前の画面で振った番号をそのまま使う（1回の送信を2つに分けない） */
        var id = f.getAttribute('data-kj-fc') || (hid && /^fc-[a-z0-9]{8,40}$/.test(hid.value) ? hid.value : newId());
        f.setAttribute('data-kj-fc', id);
        if (!hid) {
          hid = document.createElement('input');
          hid.type = 'hidden';
          hid.name = 'contact[控えID]';
          f.insertBefore(hid, f.firstChild);
        }
        hid.value = id;
        hid.disabled = false;

        var fields = {};
        for (var i = 0; i < f.elements.length; i++) {
          var el = f.elements[i];
          if (!el.name || el.disabled || SKIP[el.name]) continue;
          if (el.type === 'submit' || el.type === 'button' || el.type === 'file') continue;
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
          var v = String(el.value || '');
          if (!v) continue;
          var k = el.name.replace(/^contact\[(.*)\]$/, '$1');
          fields[k] = fields[k] ? fields[k] + ' / ' + v : v;
        }
        send({ id: id, kind: 'submit', form: f.id || '', fields: fields });
        if (session) session.setItem(FC_KEY, JSON.stringify({ id: id, at: Date.now() }));
      } catch (e3) {
        /* 控えが送れないだけ。Shopify への送信は、そのまま進む */
      }
    }, true);

    var q = location.search;
    var done = /[?&]contact_posted=true/.test(q) ||
      /^\/pages\/kiinnox_[a-z]+_thanks/.test(location.pathname) ||
      /[?&]view=kiinnox_[a-z]+_thanks/.test(q);
    if (done && session) {
      var last = null;
      try { last = JSON.parse(session.getItem(FC_KEY) || 'null'); } catch (e4) { last = null; }
      if (last && last.id && Date.now() - last.at < FC_TTL) {
        send({ id: last.id, kind: 'posted', form: '' });
      }
      session.removeItem(FC_KEY);
    }
  } catch (err) {
    /* 控えが送れないだけ。フォームは今までどおり送れる */
  }
})();
